import React from 'react';
import { EditShopProvider } from 'contexts/shop.context';
import EditShopContent from './content';

const EditShopLayout = () => {
  return (
    <EditShopProvider>
      <EditShopContent />
    </EditShopProvider>
  );
};

export default EditShopLayout;
